/**
 * CollectionTemplate Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Collection template.
 *
 * @namespace collection
 */

theme.Collection = (function () {
  var selectors = {
    productCardSlider: "[data-product-card-slider]",
    photoPrev: "[data-photo-prev]",
    photoNext: "[data-photo-next]",
    quickshop: "[data-quickshop]",
    quickshopIcon: "[data-toggle-quickshop]",
    quickshopContainer: "[data-quickshop-container]",
    sizesSlider: "[data-sizes-slider]",
    sizesPrev: "[data-sizes-prev]",
    sizesNext: "[data-sizes-next]",
    mobileAtc: "[data-mobile-atc]",
  };

  /**
   * Collection section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Collection(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr("data-section-id");
    this.settings = {};
    this.namespace = ".collection";

    this.$productCardSlider = $(selectors.productCardSlider);
    this.$quickshopIcon = $(selectors.quickshopIcon);
    this.$quickshopContainer = $(selectors.quickshopContainer);
    this.$sizesSlider = $(selectors.sizesSlider);

    this.initProductSliders();
    this.initSizesSliders();

    this.$quickshopIcon.on(
      "click" + this.namespace,
      this.toggleQuickshop.bind(this)
    );
    this.$sizesSlider.on(
      "beforeChange" + this.namespace,
      this.updateQuickshopVariant.bind(this)
    );
  }

  Collection.prototype = $.extend({}, Collection.prototype, {
    /**
     * Init product card image slider
     */
    initProductSliders: function () {
      this.$productCardSlider.each(function (index) {
        if ($(this).hasClass("slick-initialized")) return;

        var options = {
          infinite: true,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          draggable: true,
          dots: true,
        };

        $(this).slick(options);
      });
    },

    /**
     * Toggle visibility of quickshop info on mobile
     */
    toggleQuickshop: function (evt) {
      var productId = $(evt.currentTarget).data("toggle-quickshop");
      var $currentQuickshop = this.$quickshopContainer.filter(function () {
        return $(this).data("quickshop-container") == productId;
      });

      // Hide Quickshop Icon and set selected product card to `active` state
      $(evt.currentTarget).hide();
      $currentQuickshop.addClass("active");

      // reset all non-selected product cards
      this.$quickshopIcon.not($(evt.currentTarget)).show();
      this.$quickshopContainer.not($currentQuickshop).removeClass("active");
    },

    /**
     * Init mobile quickshop sizes slider
     */
    initSizesSliders: function () {
      this.$sizesSlider.each(function (index) {
        if ($(this).hasClass("slick-initialized")) return;

        var options = {
          infinite: true,
          arrows: true,
          prevArrow: $(selectors.sizesPrev, this.$container)[index],
          nextArrow: $(selectors.sizesNext, this.$container)[index],
          slidesToShow: 1,
          slidesToScroll: 1,
          draggable: true,
        };

        $(this).slick(options);
      });
    },

    /**
     * Update the variant id of the mobile atc button based on
     * the current slide's variant id
     */
    updateQuickshopVariant: function (event, slick, currentSlide, nextSlide) {
      var variantId = $(slick.$slides[nextSlide]).data("variant-id");
      var $quickshopScope = $(slick.$slider).closest(
        selectors.quickshopContainer
      );
      var $atcButton = $quickshopScope.find(selectors.mobileAtc);
      $atcButton.attr("data-quickshop", variantId);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      this.$container.off(this.namespace);
    },
  });

  return Collection;
})();

theme.SortProducts = (function () {
  var constants = {
    SORT_BY: "sort_by",
  };

  var selectors = {
    filterSelection: "#SortTags",
    sortSelection: "#SortBy",
    defaultSort: "#DefaultSortBy",
    filterButtons: "[data-filter-button]",
  };

  function SortProducts(container) {
    var $container = (this.$container = $(container));

    // Selectors
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$filterButtons = $(selectors.filterButtons, $container);

    // Event Listeners
    this.$sortSelect.on("change", this._onSortChange.bind(this));

    // Run on page load
    this.defaultSort = this._getDefaultSortValue();
    //this._resizeSelect(this.$sortSelect);
    this.$sortSelect.removeClass("hidden");
  }

  SortProducts.prototype = $.extend({}, SortProducts.prototype, {
    _onSortChange: function (evt) {
      var sort = this._sortValue();
      if (sort.length) {
        window.location.search = sort;
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = window.location.href.replace(
          window.location.search,
          ""
        );
      }
      this._resizeSelect($(evt.target));
    },

    _getSortValue: function () {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function () {
      return $(selectors.defaultSort, this.$container).val();
    },

    _sortValue: function () {
      var sort = this._getSortValue();
      var query = "";

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + "=" + sort;
      }

      return query;
    },

    _resizeSelect: function ($selection) {
      $selection.each(function () {
        var $this = $(this);

        // create test element (with same spacing as select)
        var text = $this.find("option:selected").text();
        var $test = $('<span class="btn filters-bar__button">').html(text);

        // add to body, get width, and get out
        $test.appendTo("body");
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width);
      });

      this._resizeFilterButtons();
    },

    /**
     * Force filter and sort buttons to be the same size
     */
    _resizeFilterButtons: function () {
      var largestWidth = 0;

      // get largest width
      this.$filterButtons.each(function () {
        if ($(this).outerWidth() > largestWidth) {
          largestWidth = $(this).outerWidth();
        }
      });

      this.$filterButtons.outerWidth(largestWidth);
    },

    onUnload: function () {
      this.$filterSelect.off("change", this._onFilterChange);
      this.$sortSelect.off("change", this._onSortChange);
    },
  });

  return SortProducts;
})();

$(document).ready(function () {
  if ($(".collection-loadout").length > 0) return; // don't run collection template functions on loadout page

  var sections = new slate.Sections();

  sections.register("collection", theme.Collection);
  sections.register("collection", theme.SortProducts);

  const layoutBtns = document.querySelectorAll(".layout-btn");
  const layoutDesktop = localStorage.getItem("layoutDesktop");
  const layoutMobile = localStorage.getItem("layoutMobile");

  function setGridView(layoutSetting) {
    const productGridItems = document.querySelectorAll(
      ".product-grid > .grid__item"
    );

    document.getElementById("product-grid")
      ? (document.getElementById("product-grid").dataset.layout = layoutSetting)
      : null;

    layoutBtns.forEach((btn, index) => {
      if (layoutSetting > 2 && index < 1) return;
      if (layoutSetting < 3 && index > 1) return;
      btn.classList.remove("active");
    });

    switch (layoutSetting) {
      case "1":
        layoutBtns[0].classList.add("active");
        productGridItems.forEach((item) => {
          item.classList.remove("small-down--one-half");
          item.classList.add("small-down--one-whole");
        });
        break;
      case "2":
        layoutBtns[1].classList.add("active");
        productGridItems.forEach((item) => {
          item.classList.remove("small-down--one-whole");
          item.classList.add("small-down--one-half");
        });
        break;
      case "3":
        layoutBtns[2].classList.add("active");
        productGridItems.forEach((item) => {
          item.classList.remove("medium-up--one-fifth");
          item.classList.add("medium-up--one-third");
        });
        break;
      case "5":
        layoutBtns[3].classList.add("active");
        productGridItems.forEach((item) => {
          item.classList.remove("medium-up--one-third");
          item.classList.add("medium-up--one-fifth");
        });
        break;
      default:
        layoutBtns[1].classList.add("active");
        layoutBtns[2].classList.add("active");
        break;
    }

    document
      .querySelectorAll("[data-product-card-slider]")
      .forEach((productCardSlider) => {
        if (productCardSlider.classList.contains("slick-initialized")) {
          productCardSlider.slick.refresh();
        }
      });
  }

  if (window.innerWidth > 760) {
    setGridView(layoutDesktop ?? "3");
  } else if (window.innerWidth <= 760) {
    setGridView(layoutMobile ?? "2");
  }

  layoutBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      const newLayout = btn.dataset.layout;
      setGridView(newLayout);
      if (newLayout > 2) {
        localStorage.setItem("layoutDesktop", newLayout);
      } else {
        localStorage.setItem("layoutMobile", newLayout);
      }
    });
  });

  // window.onresize = () => {
  //   if (window.innerWidth > 760 && layoutDesktop) {
  //     setGridView(layoutDesktop);
  //   } else if (window.innerWidth <= 760 && layoutMobile) {
  //     setGridView(layoutMobile);
  //   }
  // };

  function ajaxinateCallback() {
    initProductCards();

    if (window.innerWidth > 760 && layoutDesktop) {
      setGridView(layoutDesktop);
    } else if (window.innerWidth <= 760 && layoutMobile) {
      setGridView(layoutMobile);
    }
  }

  // Infinite scroll pagination script
  // if ($(".pagination-container").length > 0) {
  //   var endlessScroll = new Ajaxinate({
  //     container: ".collection-grid-container .grid",
  //     pagination: ".pagination-container",
  //     callback: ajaxinateCallback,
  //     loadingText: `<div class="text-center"><img src="https://cdn.shopify.com/s/files/1/1011/1278/files/ajax-loader.gif?v=1692637703" ></div>`,
  //     offset: 5000,
  //   });
  // }
});
